const BookingsTableDetails = {
  Title: "Bookings",
  Columns: [
    {
      headingName: "Booking Status",
      className: "col-primary",
      fieldName: "BookingStatus",
      type: "string",
    },
    {
      headingName: "Total Price",
      className: "col-number",
      fieldName: "TotalPrice",
      type: "money",
    },
    {
      headingName: "Membership Price",
      className: "col-number",
      fieldName: "MembershipPrice",
      type: "money",
    },
    {
      headingName: "Record Count",
      className: "col-number",
      fieldName: "RecordCount",
      type: "string",
    },
  ],
};

const BookingsTotalErrorsTableDetails = {
  Title: "Bookings With Total Errors",
  Columns: [
    {
      headingName: "Booking Reference",
      className: "col-primary",
      fieldName: "BookingReference",
      type: "string",
    },
    {
      headingName: "Booking Status",
      className: "col-short-name",
      fieldName: "BookingStatus",
      type: "string",
    },
    {
      headingName: "Total Booking Price",
      className: "col-number",
      fieldName: "TotalBookingPrice",
      type: "money",
    },
    {
      headingName: "Total Booking Product Price",
      className: "col-number",
      fieldName: "TotalBookingProductPrice",
      type: "money",
    },
    {
      headingName: "Total Journal Entry",
      className: "col-number",
      fieldName: "TotalJournalEntry",
      type: "money",
    },
    {
      headingName: "Total Journal Payment",
      className: "col-number",
      fieldName: "TotalJournalPayment",
      type: "money",
    },
    {
      headingName: "Created On",
      className: "col-date",
      fieldName: "CreatedOn",
      type: "datetime",
    },
    {
      headingName: "Modified On",
      className: "col-date",
      fieldName: "ModifiedOn",
      type: "datetime",
    },
  ],
};

const JournalEntriesTableDetails = {
  Title: "Non membership bookings without Journal Entries",
  Columns: [
    {
      headingName: "Booking Reference",
      className: "col-primary",
      fieldName: "Reference",
      type: "string",
    },
    {
      headingName: "Booking Status",
      className: "col-short-name",
      fieldName: "Status",
      type: "string",
    }
  ],
};

const JournalPaymentsTableDetails = {
  Title: "Non membership bookings without Journal Payments",
  Columns: [
    {
      headingName: "Booking Reference",
      className: "col-primary",
      fieldName: "Reference",
      type: "string",
    },
    {
      headingName: "Booking Status",
      className: "col-short-name",
      fieldName: "Status",
      type: "string",
    },
  ],
};

const MembershipJournalEntriesTableDetails = {
  Title: "Membership bookings without Journal Entries",
  Columns: [
    {
      headingName: "Booking Reference",
      className: "col-primary",
      fieldName: "Reference",
      type: "string",
    },
    {
      headingName: "Booking Status",
      className: "col-short-name",
      fieldName: "Status",
      type: "string",
    },
  ],
};


const MembershipJournalPaymentsTableDetails = {
  Title: "Membership bookings without Journal Payments",
  Columns: [
    {
      headingName: "Booking Reference",
      className: "col-primary",
      fieldName: "Reference",
      type: "string",
    },
    {
      headingName: "Booking Status",
      className: "col-short-name",
      fieldName: "Status",
      type: "string",
    },
  ],
};


const ReprocessedBookingsTableDetails = {
  Title: "Reprocessed bookings",
  Columns: [
    {
      headingName: "Booking Reference",
      className: "col-primary",
      fieldName: "Reference",
      type: "string",
    },
    {
      headingName: "Booking Status",
      className: "col-short-name",
      fieldName: "Status",
      type: "string",
    },
  ],
};

const SuccessfulReprocessedBookingsTableDetails = {
  Title: "Successfully Reprocessed bookings",
  Columns: [
    {
      headingName: "Booking Reference",
      className: "col-primary",
      fieldName: "Reference",
      type: "string",
    },
    {
      headingName: "Booking Status",
      className: "col-short-name",
      fieldName: "Status",
      type: "string",
    },
  ],
};

export {
  BookingsTableDetails,
  BookingsTotalErrorsTableDetails,
  JournalEntriesTableDetails,
  JournalPaymentsTableDetails,
  MembershipJournalEntriesTableDetails,
  MembershipJournalPaymentsTableDetails,
  ReprocessedBookingsTableDetails,
  SuccessfulReprocessedBookingsTableDetails,
};
